const DELIVERY_LOCATION_POSTAL_CODE_LOCAL_STORAGE_KEY = "hmDl";
const HOME_WAREHOUSE_POSTAL_CODE_LOCAL_STORAGE_KEY = "prWh";
export {
  DELIVERY_LOCATION_POSTAL_CODE_LOCAL_STORAGE_KEY,
  HOME_WAREHOUSE_POSTAL_CODE_LOCAL_STORAGE_KEY
};
